import React from 'react'
import './styles.scss'

export default function AccordionModule({ items }) {
  return (
    <>
      {items && (
        <div className="dhsv-accordion">
          <div className="row">
            <div className="col-12">
              <div className="accordion">
                {items.map((item, key) => (
                  <>
                    {item.title && item.description ? (
                      <div className="accordion-item" key={key}>
                        {item.title && (
                          <button
                            className={'accordion-item__title'}
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          />
                        )}
                        {item.description && (
                          <div
                            className="accordion-item__desc"
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      <>{item}</>
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
